/* NOCTURNE theme scripts */

(function () {
  'use strict';

  /* --- Mobile nav drawer -------------------------------------------------- */
  const toggle = document.querySelector('[data-nav-toggle]');
  const drawer = document.querySelector('[data-nav-drawer]');
  const closeBtn = document.querySelector('[data-nav-close]');

  function setDrawer(open) {
    if (!drawer) return;
    drawer.setAttribute('data-open', String(open));
    document.body.style.overflow = open ? 'hidden' : '';
    if (open) {
      const first = drawer.querySelector('a');
      if (first) first.focus();
    } else if (toggle) {
      toggle.focus();
    }
  }

  if (toggle) toggle.addEventListener('click', () => setDrawer(true));
  if (closeBtn) closeBtn.addEventListener('click', () => setDrawer(false));
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') setDrawer(false);
  });
  if (drawer) {
    drawer.querySelectorAll('a').forEach((a) =>
      a.addEventListener('click', () => setDrawer(false))
    );
  }

  /* --- Quantity steppers -------------------------------------------------- */
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const step = btn.dataset.step === 'up' ? 1 : -1;
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* --- Variant picker ----------------------------------------------------- */
  document.querySelectorAll('[data-variant-picker]').forEach((form) => {
    const dataEl = form.querySelector('[data-variant-json]');
    if (!dataEl) return;

    let variants = [];
    try {
      variants = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    const idInput = form.querySelector('[data-variant-id]');
    const priceEl = form.querySelector('[data-price]');
    const submit = form.querySelector('[data-add]');
    const groups = Array.from(form.querySelectorAll('[data-option-group]'));

    function selected() {
      return groups.map((g) => {
        const active = g.querySelector('[aria-pressed="true"]');
        return active ? active.dataset.value : null;
      });
    }

    function match(choice) {
      return variants.find((v) =>
        choice.every((val, i) => val === null || v.options[i] === val)
      );
    }

    function render() {
      const choice = selected();
      const variant = match(choice);

      // Mark unavailable combinations
      groups.forEach((g, gi) => {
        g.querySelectorAll('[data-value]').forEach((btn) => {
          const test = choice.slice();
          test[gi] = btn.dataset.value;
          const candidate = variants.find((v) =>
            test.every((val, i) => val === null || v.options[i] === val)
          );
          btn.dataset.unavailable = String(!candidate || !candidate.available);
        });
      });

      if (!variant) {
        if (submit) {
          submit.disabled = true;
          submit.textContent = form.dataset.unavailableText || 'Unavailable';
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceEl && variant.price_formatted) priceEl.textContent = variant.price_formatted;

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available
          ? form.dataset.addText || 'Add to cart'
          : form.dataset.soldOutText || 'Sold out';
      }

      if (variant.id && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
    }

    groups.forEach((g) => {
      g.querySelectorAll('[data-value]').forEach((btn) => {
        btn.addEventListener('click', () => {
          g.querySelectorAll('[data-value]').forEach((b) =>
            b.setAttribute('aria-pressed', 'false')
          );
          btn.setAttribute('aria-pressed', 'true');
          render();
        });
      });
    });

    render();
  });

  /* --- Cart line removal / quantity update -------------------------------- */
  document.querySelectorAll('[data-cart-remove]').forEach((btn) => {
    btn.addEventListener('click', async () => {
      btn.disabled = true;
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.key, quantity: 0 })
      });
      window.location.reload();
    });
  });

  document.querySelectorAll('[data-cart-qty]').forEach((input) => {
    input.addEventListener('change', async () => {
      await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          id: input.dataset.key,
          quantity: Math.max(0, parseInt(input.value, 10) || 0)
        })
      });
      window.location.reload();
    });
  });

  /* --- Hero video: pause when off-screen ---------------------------------- */
  const heroVideo = document.querySelector('[data-hero-video]');
  if (heroVideo && 'IntersectionObserver' in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const p = heroVideo.play();
            if (p && p.catch) p.catch(() => {});
          } else {
            heroVideo.pause();
          }
        });
      },
      { threshold: 0.1 }
    );
    io.observe(heroVideo);
  }
})();
